(function(angular) {
  'use strict';

  angular.module('aprima-provider-api').factory('PrmUserRepository', [
    'AprimaAnalytics',
    'AprimaRestangular',
    PrmUserRepository
  ]);

  function PrmUserRepository(
    AprimaAnalytics,
    AprimaRestangular
  ) {
      var service = {
        getUser: getUser,
        searchUsers: searchUsers,
      };

      return service;

      function getUser(uid) {
        var timing = AprimaAnalytics.startTiming('PrmUserRepository', 'api', 'getUser');
        var restangular = AprimaRestangular.get();
        return restangular.all('view-find-user')
          .one(uid)
          .get()
          .finally(timing.stop);
      }

      function searchUsers(inputSearch) {
        //gets rid of all new line characters
        inputSearch = inputSearch.replace(/\n|\r/g, '');

        var timing = AprimaAnalytics.startTiming('PrmUserRepository', 'api', 'searchUsers');
        var restangular = AprimaRestangular.get();

        return restangular
        .one('view-find-user/quick-search')
        .get({quicksearch: inputSearch})
        .finally(timing.stop);
      }
  }

})(window.angular);